import { SkeletonPageHeader } from '@/features/_components/skeletons'

export const GuarantorHeaderSkeleton = () => {
  return (
    <SkeletonPageHeader titleWidth="w-48" subtitle={{ width: 'w-40' }} tabs={[{ width: 'w-16' }]} />
  )
}
